import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './InternalInstrumentsEditor.html?raw';

import MainCatalogsEditorBaseV2 from '../../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";
import HintBox from '../../../../moreCore/UI/HintBox/HintBox';
import _GlobalSelectEntityDialogsMixin from '../../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../../moreCore/_loadingHelpers/SelectEntityDialog";
import { ExpandableSection, ExpandableSectionMarkings } from "../../../../moreCore/UI/Container/ExpandableSectionTypes";
import StaticTable from '../../../../moreCore/UI/StaticTable/StaticTable';
import UserHistoryEditor from './UserHistory/UserHistoryEditor';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import { DateHelpers } from "../../../../more/Helpers";
import SearchSelect from '../../../../moreCore/UI/SearchSelect/SearchSelect';
import MultiLangEdit from '../../../../moreCore/UI/MultiLangEdit/MultiLangEdit';

interface UserHistoryEntry {
    ID: string;
    gDisp_1: string;
    date_start: string;
    date_end: string;
    isDeleted?: boolean;
}
interface MaterialEntry {
    assignmentID: string;
    materialID: string;
    description: string;
    isDeleted?: boolean;
}
interface MaterialData {
    ID: string;
    description: string;
}
class InternalInstrumentsEditor extends compose(MainCatalogsEditorBaseV2, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private isMusicianProfile: boolean;
    private materialsReadonly: boolean;

    private input_Category: MdsLax<InstanceType<typeof SearchSelect>>;
    private input_Description: MdsLax<InstanceType<typeof MultiLangEdit<any>>>;

    private inputOwner: MdsLax<InstanceType<typeof HintBox>>;
    private inputManufacturer: MdsLax<InstanceType<typeof HintBox>>;
    private inputMaterials: MdsLax<InstanceType<typeof HintBox>>;

    private expanderUserHistory: MdsLax<InstanceType<typeof ExpandableSection>>;
    private expanderMaterials: MdsLax<InstanceType<typeof ExpandableSection>>;

    private userHistoryTable: MdsLax<InstanceType<typeof StaticTable>>
    private materialsTable: MdsLax<InstanceType<typeof StaticTable>>

    private userHistoryTableContainer: HTMLElement;
    private materialsTableContainer: HTMLElement;


    private userHistoryEntries: Array<UserHistoryEntry> = [];
    private selectedMaterials: Array<MaterialEntry> = [];

    private userHistoryEditor: MdsLax<InstanceType<typeof UserHistoryEditor>> = null;
    private userHistoryChangedData: {} = null;
    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    isValid(): boolean {
        let isValid = true;

        console.log(this.input_Description.isValid, this.input_Category.isValid)

        isValid = this.input_Description.isValid && isValid;
        isValid = this.input_Category.getValue() && isValid;


        return isValid;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let cowner = this.getAttributeValue("cowner");
        let owner = this.getAttributeValue("ref_owner");

        let cmanufacturer = this.getAttributeValue("cmanufacturer");
        let manufacturer = this.getAttributeValue("ref_manufacturer");

        if (cowner && !owner) {
            this.inputOwner.setValue(cowner, true);
        }

        if (cmanufacturer && !manufacturer) {
            this.inputManufacturer.setValue(cmanufacturer, true);
        }
        this.userHistoryEntries = lang.clone(this.getAttributeValue("userHistory"));
        this.userHistoryEntries.forEach(e => {
            e.date_start = DateHelpers.dateToLocalISOString(e.date_start as any);
            e.date_end = DateHelpers.dateToLocalISOString(e.date_end as any);
        })
        this.selectedMaterials = lang.clone(this.getAttributeValue("materials"));

        this.updateUserHistoryTable();
        this.updateMaterialsTable();
    }

    private _onChangeInputOwner(value) {
        //
    }
    private _onChangeInputManufacturer() {
        //
    }
    private _onChangeMaterial() {

        let value = this.inputMaterials.getValue() as MaterialData;

        this.addNewMaterialEntry(value);

        this.inputMaterials.setValue(null, true);
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.InternalInstrument;
    }

    private _onClick_OpenSED(identifierName, evt) {

        this.loadSelectEntityDialog(evt,
            identifierName,
            lang.hitch(this, this._onCallback_Dlg)
        );
    }

    private _onCallback_Dlg(mode: string, data, items: Array<SelectEntityDialogTypes.Item<any>>) {
        // fake-entity falls das zurückgeleiferte Entity aus items[0].entry.data nicht dem entspricht das die liste erwartet

        if (!items || !items.length) return;
        let entity = null;

        switch (mode) {
            case "selectInstrumentOwner":

                entity = {
                    ID: items[0].entry.value, gDisp_1: items[0].entry.label
                }

                this.inputOwner.setValue(entity)
                break;
            case "selectInstrumentManufacturer":

                entity = {
                    ID: items[0].entry.value, gDisp_1: items[0].entry.label
                }

                this.inputManufacturer.setValue(entity)
                break;
            case "selectMaterial":

                for (let item of items) {
                    let entity: Partial<MaterialData> = item.entry?.data;
                    if (!entity) {
                        entity = {
                            ID: item.entry.value, description: item.entry.label
                        };
                    }
                    this.addNewMaterialEntry(entity as any);
                }
                break;
        }
    }

    private _onRowClick(row: StaticTable.StaticTableRow<UserHistoryEntry>, rowGroup, evt) {

        if (evt.target.className == "actionsColumn") return;

        let entity: UserHistoryEntry = row.rowGroup.entity;

        this.userHistoryChangedData = null;

        if (this.dlg != null) this.dlg.destroy();
        if (this.userHistoryEditor != null) this.userHistoryEditor.destroy();

        this.dlg = new GenericDialog();
        this.userHistoryEditor = new UserHistoryEditor();

        this.userHistoryEditor.setData(entity);
        this.userHistoryEditor.on("UserHistoryEditor_ChacgedData", (cd) => { this.userHistoryChangedData = cd; });

        this.dlg.show(this.userHistoryEditor, entity.gDisp_1, null, null, "okcancel", lang.hitch(this, this.processUserHistoryNewData, entity), { closeOnEscape: true, size: "smaller" });
    }

    private processUserHistoryNewData(entity: UserHistoryEntry, dlgResult: Number) {

        if (dlgResult === 0 && this.userHistoryChangedData === null) return;

        let i = 0;
        for (let e of this.userHistoryEntries) {
            if (e.ID === entity.ID) break;
            i++;
        }

        for (let p in this.userHistoryChangedData) {

            switch (p) {
                case "date_start":
                case "date_end":
                    this.userHistoryEntries[i][p] = DateHelpers.dateToLocalISOString(this.userHistoryChangedData[p]);
                    break;
                default:
                    this.userHistoryEntries[i][p] = this.userHistoryChangedData[p]
            }
        }

        this.setAttributeValue("userHistory", lang.clone(this.userHistoryEntries));
        this.updateUserHistoryTable();
    }

    private _setUpTables(response: { layouts: Array<any> }) {

        if (this.userHistoryTable != null) this.userHistoryTable.destroy();
        if (this.materialsTable != null) this.materialsTable.destroy();

        this.userHistoryTable = new StaticTable();
        this.userHistoryTable.placeAt(this.userHistoryTableContainer);

        let map = response.layouts.map((l) => { return l.name; });

        this.userHistoryTable.setLayout(response.layouts[map.indexOf("userHistory")]);

        if (!this.isMusicianProfile) this.userHistoryTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeUserFromHistory));

        this.userHistoryTable.setRowClick(lang.hitch(this, this._onRowClick))
        this.userHistoryTable.setCyAttribute("InternalInstrumentsEditorUserHistoryTable");

        this.updateUserHistoryTable();


        this.materialsTable = new StaticTable();
        this.materialsTable.placeAt(this.materialsTableContainer);

        this.materialsTable.setLayout(response.layouts[map.indexOf("materials")]);

        if (!this.materialsReadonly) this.materialsTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeMaterial));

        //this.materialsTable.setRowClick(lang.hitch(this, this._onRowClick))
        this.materialsTable.setCyAttribute("InternalInstrumentsEditorMaterialsTable");

        this.updateMaterialsTable();
    }
    private updateUserHistoryTable() {

        let userHistoryEntries: Array<UserHistoryEntry> = lang.clone(this.getAttributeValue("userHistory"));

        userHistoryEntries?.length > 0 ? this.expanderUserHistory.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderUserHistory.setMarking(ExpandableSectionMarkings.default);

        if (this.userHistoryTable) {
            this.userHistoryTable.setData(userHistoryEntries);

            userHistoryEntries?.forEach(s => {
                if (s.isDeleted === true) {
                    this.disableNode(this.userHistoryTable.getRowGroupByKeyValue(s.ID, "ID").rows[0].node);
                }
            })
        }
        
    }

    private updateMaterialsTable() {

        let selecteMaterials: Array<MaterialEntry> = lang.clone(this.getAttributeValue("materials"));

        selecteMaterials?.length > 0 ? this.expanderMaterials.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderMaterials.setMarking(ExpandableSectionMarkings.default);


        if (this.materialsTable) {
            this.materialsTable.setData(selecteMaterials);

            selecteMaterials?.forEach(s => {
                if (s.isDeleted === true) {
                    this.disableNode(this.materialsTable.getRowGroupByKeyValue(s.assignmentID, "assignmentID").rows[0].node);
                }
            })
        }
    }
    private removeUserFromHistory(rowGr: StaticTable.StaticTableRowGroup<UserHistoryEntry>) {

        let entry = rowGr.entity;
        let deletedEntry = this.userHistoryEntries.filter(x => x.ID === entry.ID)[0];

        if (entry.ID == null) {

            alert("FEHLER! Es sollten keine neuen Einträge verfügbar sein!")
        } else {

            deletedEntry.isDeleted = true;
        }

        this.setAttributeValue("userHistory", lang.clone(this.userHistoryEntries));
        this.updateUserHistoryTable();
    }
    private removeMaterial(rowGr: StaticTable.StaticTableRowGroup<MaterialEntry>) {

        let entry = rowGr.entity;
        let deletedEntry = this.selectedMaterials.filter(x => x.materialID === entry.materialID && x.assignmentID === entry.assignmentID)[0];

        if (entry.assignmentID == null) {

            this.selectedMaterials.splice(this.selectedMaterials.indexOf(deletedEntry), 1);
        } else {

            deletedEntry.isDeleted = true;
        }

        this.setAttributeValue("materials", lang.clone(this.selectedMaterials));
        this.updateMaterialsTable();
    }
    private addNewMaterialEntry(value: MaterialData) {
        if (value == null) return;

        let existingEntry = this.selectedMaterials.filter(x => x.materialID === value.ID)[0];
        if (existingEntry && existingEntry.isDeleted !== true) {
            //this.showToast(`${value.description} allready in list!`);
            this.showToast({
                title: this.translate("MainCatalogsEditor_MATERIALS_Toast_ExistInList"),
                message: `**${value.description}**  ${this.translate("MainCatalogsEditor_MATERIALS_Toast_ExistInList_details")}`,
                messageIcon: "fas fa-info-circle",
                iconClass: "fas fa-info-circle"
            })
            return;
        }

        if (existingEntry && existingEntry.isDeleted === true) {

            existingEntry.isDeleted = false;
            this.setAttributeValue("materials", lang.clone(this.selectedMaterials));
            this.updateMaterialsTable();
            return;
        }

        let fakeEntry: MaterialEntry = {
            assignmentID: null,
            materialID: value.ID,
            description: value.description
        }

        this.selectedMaterials.push(fakeEntry);
        this.setAttributeValue("materials", lang.clone(this.selectedMaterials));

        this.updateMaterialsTable();
    }

   

    setReadonly(readOnly: boolean | "initial") {
        super.setReadonly.apply(this, arguments as any);


        this.materialsReadonly = true;
        this.disableNode(this.materialsTableContainer);
        this.inputMaterials.setReadonly(true);
    }

    setReadOnlyForMusicianProfile(): void {

        this.disableNode(this.userHistoryTableContainer);
        this.isMusicianProfile = true;

       
        this.inputOwner.setReadonly(true);
    }
    loadDefaultDataForMusicianProfile() {
        this.useStandbyManager = true;
        this.StandbyStart(this.domNode, "defaultDataLoad");
        let entityID = this.getCurrentUserId();

        let jsonData = {
            entityID: entityID,
            mode: "defaultData"
        };

        this.RequestManager.callfunction("Webtool_API_MusicianProfile__LoadData",
            jsonData,
            lang.hitch(this, this._onLoadDataResponse),
            (err) => {
                this.showToast({
                    title: "Error!",
                    message: err.Message,
                    messageIcon: "fas fa-exclamation-circle warningTXT",
                    iconClass: "fas fa-exclamation-circle warningTXT"
                }) });
    }
    private _onLoadDataResponse(response) {

        this.StandbyStop("defaultDataLoad");
        this.useStandbyManager = false;
        this.setAttributeValue("ref_owner", response.owner);
        this.setAttributeValue("ref_ownership_structure", response.ownership);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetInternalInstrumentListsTablesLayouts",
            null,
            lang.hitch(this, this._setUpTables),
            (err) => { this.showToast(err.Message) }
        )

        this.inputOwner.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectInstrumentOwner"));
        this.inputManufacturer.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectInstrumentManufacturer"));
        this.inputMaterials.addInlineButton(lang.hitch(this, this._onClick_OpenSED, "selectMaterial"));
        
        this.inputManufacturer.addAdditionalRequestParameter("mode", "manufacturer");
        this.inputMaterials.addAdditionalRequestParameter("mode", "material");
        
        this.SEDconfigCallfunction = "Webtool_API_MainCatalogsEditor__SED_GetConfig";
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(InternalInstrumentsEditor);